// import file extension
const EXTENSION = {
  xlsx: "xlsx",
};

const getYYYYMMDD = () => {
  const twoDigits = (num) => (Number(num) / 10 < 1 ? `0${num}` : num);
  const date = new Date();
  return `${date.getFullYear()}-${twoDigits(date.getMonth() + 1)}-${twoDigits(
    date.getDate()
  )}-${twoDigits(date.getHours())}${twoDigits(date.getMinutes())}`;
};

// 每個 pattern 設定:
// - excel 要有哪些欄位
const importConfig = {
  EXTENSION,
  pattern: {
    hsna_sna: {
      name: "hsna_sna",
      extension: EXTENSION.xlsx,
      // 必須要有以下欄位
      fileCols: [
        "起點",
        "終點",
        "原始資料",
        "關係",
        "主事件分類",
        "子事件分類",
      ],
    },
    hsna_gis: {
      name: "hsna_gis",
      extension: EXTENSION.xlsx,
      // 必須要有以下欄位
      // fileCols: ["srcId", "srcLabel", "dstId", "dstLabel"],
    },
  },
};

export default importConfig;
